// eslint-disable-next-line import/prefer-default-export
export const disableArrowPopperConfig = {
  modifiers: {arrow: {enabled: false}, keepTogether: {enabled: false}},
}
